import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../AuthContext';
import MainStructure from '../../components/general/MainStructure';
import LoadingSpinner from '../../components/LoadingSpinner/LoadingSpinner';

import format from 'date-fns/format';
import addDays from 'date-fns/addDays';
import startOfWeek from 'date-fns/startOfWeek';

import * as Icon from 'react-feather'
import { ProfilePicture } from '../../components/general/AccountIcons';

import ximage from "../../assets/twitter.png"
import linkedinimage from "../../assets/linkedin.png"
import instagramimage from "../../assets/instagram.png"
import youtubeimage from "../../assets/youtube.png"
import tiktok from "../../assets/tiktok.png"
import threads from "../../assets/threads.png"
import instagram from "../../assets/instagram.png"
import blueskyimage from "../../assets/bluesky.png"
import discordimage from "../../assets/discord.png"
import facebook from "../../assets/facebook.png"
import pinterest from "../../assets/pinterest.png"

// Utility functions
const getWeekDates = (date = new Date()) => {
  const start = startOfWeek(date, { weekStartsOn: 1 }); // Monday start
  return Array.from({ length: 7 }, (_, i) => addDays(start, i));
};

const groupPostsByDate = (posts) => {
  return posts.reduce((acc, post) => {


    const dateParts = post.scheduled_date.split(/[- :]/);
    const date = new Date(Date.UTC(dateParts[0], dateParts[1] - 1, dateParts[2], dateParts[3], dateParts[4], dateParts[5]));
    const dateKey = date.toDateString();


    if (!acc[dateKey]) acc[dateKey] = [];
    acc[dateKey].push(post);
    return acc;
  }, {});
};



function Calendar() {
  const navigate = useNavigate();
  const myContext = useAuth();

  const [showTrashModal, setShowTrashModal] = useState(false);
const [postToTrash, setPostToTrash] = useState(null);
const [isTrashing, setIsTrashing] = useState(false);


  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentDate, setCurrentDate] = useState(new Date());

  const mySocialAccounts = myContext.accounts;

  // Treat linkedin_page as linkedin so only one LinkedIn icon appears in the channel bar
  const availableTypes = ['all', ...new Set(mySocialAccounts.map(acc => acc.type === 'linkedin_page' ? 'linkedin' : acc.type))];

  function fetchMyPosts()
  {
    const tokenFromLocalStorage = localStorage.getItem('jwtToken');
  const formattedDate = format(currentDate, 'yyyy-MM-dd');

    fetch('https://api.schedpilot.com/wp-json/api/v1/getAllPostsForCalendar', {
      method: 'POST',credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ current_date: formattedDate })
    })
      .then(response => response.json())
      .then(myData => {
        const data = myData.scheduled || [];
        setPosts(data);
        setLoading(false);
      })
      .catch(error => {
        console.error('Error fetching posts:', error);
        setLoading(false);
      });
  }

  useEffect(() => {
    fetchMyPosts();
  }, [currentDate]);



const [showQuickDateModal, setShowQuickDateModal] = useState(false);
const [pendingDate, setPendingDate] = useState(null); // Stores the day clicked
const [selectedTime, setSelectedTime] = useState("09:00"); // Default time


  const weekDates = getWeekDates(currentDate);

const [selectedType, setSelectedType] = useState('all');


  const filteredPosts = selectedType === 'all'
    ? posts
    : posts.filter(post =>
        post.accounts && post.accounts.some(acc =>
          selectedType === 'linkedin'
            ? (acc.type === 'linkedin' || acc.type === 'linkedin_page')
            : acc.type === selectedType
        )
      );

  const groupedPosts = groupPostsByDate(filteredPosts);

  const renderTikTokBadge = (status) => {
    if (!status) return null;

    let badgeClass = "bg-secondary";
    let icon = <Icon.Loader size={12} className="mr-1" />;
    let label = status;

    if (status.includes("PROCESSING")) {
      badgeClass = "bg-warning text-dark";
      label = "Processing";
    } else if (status === "PUBLISH_COMPLETE" || status === "SUCCESS") {
      badgeClass = "bg-success";
      icon = <Icon.Check size={12} className="mr-1" />;
      label = "Live";
    } else if (status === "FAILED") {
      badgeClass = "bg-danger";
      icon = <Icon.AlertCircle size={12} className="mr-1" />;
      label = "Failed";
    } else if (status === "SENT_TO_INBOX" || status === "SEND_TO_USER_INBOX") {
      badgeClass = "bg-info";
      icon = <Icon.Smartphone size={12} className="mr-1" />;
      label = "Check App To Publish";
    }




    return (
      <span className={`badge ${badgeClass} d-inline-flex align-items-center mt-1 mr-1`} style={{fontSize: '10px'}}>
        {icon} {label}
      </span>
    );
  };


  async function handleMoveToTrash() {
  if (!postToTrash) return;
  setIsTrashing(true);
  try {
    const response = await fetch('https://api.schedpilot.com/wp-json/api/v1/deleteScheduledPost', {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ postId: postToTrash.id })
    });

    if (response.ok) {
      // 1. Remove from local state so UI updates immediately
      setPosts(posts.filter(p => p.id !== postToTrash.id));
      // 2. Close modal
      setShowTrashModal(false);
      // Optional: toast.success("Post moved to trash");
    }
  } catch (error) {
    console.error('Error trashing post:', error);
  } finally {
    setIsTrashing(false);
    setPostToTrash(null);
  }
}



  const weekRangeLabel = () => {
    const start = weekDates[0];
    const end = weekDates[6];
    return `${format(start, 'dd MMM yyyy')} - ${format(end, 'dd MMM yyyy')}`;
  };

function formatDateToUserTimezone(gmtDate) {
        // Parse the GMT date string into a Date object
        const dateParts = gmtDate.split(/[- :]/);
        const date = new Date(Date.UTC(dateParts[0], dateParts[1] - 1, dateParts[2], dateParts[3], dateParts[4], dateParts[5]));

        // Format the date according to the user's locale and timezone
        const formattedDate = date.toLocaleString(undefined, {
          timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
          hour12: true, // Use 12-hour format
          hour: 'numeric', // Display hours
          minute: 'numeric', // Display minutes

        });

        return formattedDate;
      }

function getTimezoneAbbr(tz) {
  if (!tz) return null;
  try {
    // "America/New_York" → "New York", "Europe/Bucharest" → "Bucharest", "UTC" → "UTC"
    const parts = tz.split('/');
    return parts[parts.length - 1].replace(/_/g, ' ');
  } catch {
    return tz;
  }
}

function displayIcons(accountsArray) {
  return (
    <div className="d-flex flex-wrap" style={{ rowGap: 6, minWidth: 0 }}>
      {accountsArray.map((account, index) => (
        <div key={index} className="mr-3 position-relative d-flex align-items-center">
          {/* Social Media App Icon */}
          {account.type === "twitter" && (
            <img
              src={ximage}
              alt="Twitter"
              style={{ width: 28, height: 28 }}
            />
          )}
          {account.type === "linkedin" && (
            <img
              src={linkedinimage}
              alt="LinkedIn"
              style={{ width: 28, height: 28 }}
            />
          )}

             {account.type === "linkedin_page" && (
            <img
              src={linkedinimage}
              alt="LinkedIn"
              style={{ width: 28, height: 28 }}
            />
          )}

               {account.type === "instagram" && (
            <img
              src={instagram}
              alt="instagram"
              style={{ width: 28, height: 28 }}
            />
          )}


               {account.type == "pinterest" && (
            <img
              src={pinterest}
              alt="pinterest"
              style={{ width: 28, height: 28 }}
            />
          )}



               {account.type === "tiktok" && (
            <img
              src={tiktok}
              alt="tiktok"
              style={{ width: 28, height: 28 }}
            />
          )}

                         {account.type === "bluesky" && (
            <img
              src={blueskyimage}
              alt="bluesky"
              style={{ width: 28, height: 28 }}
            />
          )}

          {account.type === "discord" && (
            <img
              src={discordimage}
              alt="discord"
              style={{ width: 28, height: 28 }}
            />
          )}



               {account.type === "threads" && (
            <img
              src={threads}
              alt="threads"
              style={{ width: 28, height: 28 }}
            />
          )}




               {account.type === "facebook" && (
            <img
              src={facebook}
              alt="facebook"
              style={{ width: 28, height: 28 }}
            />
          )}


      {account.type === "youtube" && (
            <img
              src={youtubeimage}
              alt="youtube"
              style={{ width: 28, height: 28 }}
            />
          )}

          {/* User Profile Image */}
          <ProfilePicture
            src={account.picture || account.image}
            name={account.name}
            size={25}
            style={{
              position: "absolute",
              left: 15,
              top: 12,
              border: "2px solid white",
              backgroundColor: "#fff"
            }}
          />
        </div>
      ))}
    </div>
  );
}



  // Helper to map type to the correct image asset for the filter bar
  const getTypeIcon = (type) => {
    switch(type) {
      case 'twitter': return ximage;
      case 'linkedin': return linkedinimage;
      case 'instagram': return instagram;
      case 'facebook': return facebook;
      case 'youtube': return youtubeimage;
      case 'tiktok': return tiktok;
      case 'threads': return threads;
      case 'bluesky': return blueskyimage;
      case 'discord': return discordimage;
      case 'pinterest': return pinterest;
      default: return null;
    }
  };


const generateTimeSlots = () => {
  const slots = [];
  for (let hour = 0; hour < 24; hour++) {
    // Increment by 10 minutes instead of 30
    for (let minute = 0; minute < 60; minute += 10) {
      const h = hour.toString().padStart(2, '0');
      const m = minute.toString().padStart(2, '0');
      slots.push(`${h}:${m}`);
    }
  }
  return slots;
};



  return (

  <div className="container-fluid p-0">
        <div className="d-flex">
          <div className='flex-grow-1'>
            <div className='d-flex justify-content-between align-items-end mb-4'>




            <div className="d-flex align-items-center bg-white p-2   shadow-sm border" style={{borderRadius: "12px"}}>

                {availableTypes.map(type => (
                  <div
                    key={type}
                    onClick={() => setSelectedType(type)}
                    style={{
                      cursor: 'pointer',
                      padding: '5px 10px',
                      borderRadius: '10px',
                      backgroundColor: selectedType === type ? '#f0f2f5' : 'transparent',
                      border: selectedType === type ? '1px solid #dee2e6' : '1px solid transparent',
                      transition: 'all 0.2s'
                    }}
                    className="mx-1 d-flex align-items-center"
                  >
                    {type === 'all' ? (
                      <span style={{fontSize: '16px', fontWeight: 600}}>All</span>
                    ) : (
                      <img src={getTypeIcon(type)} alt={type} style={{ width: 30, height: 30 }} />
                    )}
                  </div>
                ))}
              </div>
            </div>




            {loading ? (
              <LoadingSpinner />
            ) : (
              <div style={{overflowX:"hidden"}}>
                {/* Week navigation bar */}
                <div className="d-flex justify-content-between align-items-center mb-4"
                     style={{ background: '#fff', border: '1px solid #e8edf2', borderRadius: 14, padding: '10px 16px' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                    <button
                      onClick={() => { setCurrentDate(addDays(currentDate, -7)); fetchMyPosts(); }}
                      style={{ background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: 8, width: 34, height: 34, display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', color: '#475569' }}
                      onMouseOver={e => e.currentTarget.style.background = '#f1f5f9'}
                      onMouseOut={e => e.currentTarget.style.background = '#f8fafc'}
                    ><Icon.ChevronLeft size={16} strokeWidth={2.5} /></button>
                    <button
                      onClick={() => { setCurrentDate(addDays(currentDate, 7)); fetchMyPosts(); }}
                      style={{ background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: 8, width: 34, height: 34, display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', color: '#475569' }}
                      onMouseOver={e => e.currentTarget.style.background = '#f1f5f9'}
                      onMouseOut={e => e.currentTarget.style.background = '#f8fafc'}
                    ><Icon.ChevronRight size={16} strokeWidth={2.5} /></button>
                    <button
                      onClick={() => { setCurrentDate(new Date()); fetchMyPosts(); }}
                      style={{ background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: 8, padding: '0 12px', height: 34, fontSize: '0.78rem', fontWeight: 600, cursor: 'pointer', color: '#475569' }}
                      onMouseOver={e => e.currentTarget.style.background = '#f1f5f9'}
                      onMouseOut={e => e.currentTarget.style.background = '#f8fafc'}
                    >Today</button>
                  </div>
                  <div style={{ fontWeight: 600, fontSize: '0.95rem', color: '#0f172a' }}>{weekRangeLabel()}</div>
                  <div style={{ fontSize: '0.78rem', color: '#94a3b8', fontWeight: 500 }}>{posts.length} post{posts.length !== 1 ? 's' : ''} this week</div>
                </div>

                <div className="row g-2">
                  {weekDates.map(date => {
                    const dateKey = date.toDateString();
                    const dayPosts = groupedPosts[dateKey] || [];
                    const isToday = date.toDateString() === new Date().toDateString();
                    const isPast = date < new Date(new Date().setHours(0, 0, 0, 0));
                    const isWeekend = date.getDay() === 0 || date.getDay() === 6;
                    return (
                      <div key={dateKey} className="col mb-2" style={{ minWidth: 0, maxWidth: 'calc(100% / 7)' }}>

                        {/* Day header */}
                        <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginBottom: 8 }}>
                          <div style={{ width: 32, height: 32, borderRadius: '50%', background: isToday ? '#4f46e5' : 'transparent', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                            <span style={{ fontSize: '0.82rem', fontWeight: 700, color: isToday ? '#fff' : isWeekend ? '#94a3b8' : '#0f172a' }}>
                              {format(date, 'd')}
                            </span>
                          </div>
                          <div>
                            <div style={{ fontSize: '0.7rem', fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.06em', color: isToday ? '#4f46e5' : isWeekend ? '#94a3b8' : '#64748b' }}>
                              {format(date, 'EEE')}
                            </div>
                            <div style={{ fontSize: '0.65rem', color: '#94a3b8', fontWeight: 500 }}>{format(date, 'MMM')}</div>
                          </div>
                          {dayPosts.length > 0 && (
                            <span style={{ marginLeft: 'auto', background: isToday ? '#eef2ff' : '#f1f5f9', color: isToday ? '#4f46e5' : '#64748b', fontSize: '0.65rem', fontWeight: 700, borderRadius: 20, padding: '1px 7px' }}>
                              {dayPosts.length}
                            </span>
                          )}
                        </div>

                        {/* Empty state */}
                        {dayPosts.length === 0 ? (
                          <div style={{ minHeight: 110, background: isToday ? '#fafbff' : '#fafafa', borderRadius: 12, border: `1px dashed ${isToday ? '#c7d2fe' : '#e2e8f0'}`, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                            <Icon.Inbox size={20} style={{ color: '#cbd5e1', marginBottom: 4 }} strokeWidth={1.5} />
                            <div style={{ fontSize: '0.7rem', fontWeight: 600, color: '#94a3b8' }}>No posts</div>
                          </div>
                        ) : (
                          dayPosts.map(post => {
                            const isPendingApproval = post.post_status === 'pending_approval';
                            const status = isPendingApproval ? 'pending_approval' : (post.derived_status || 'scheduled');
                            const accentColor = status === 'posted' ? '#22c55e' : status === 'failed' ? '#ef4444' : status === 'processing' ? '#f59e0b' : status === 'pending_approval' ? '#7c3aed' : '#4f46e5';
                            const badgeStyle = {
                              posted:           { bg: '#dcfce7', color: '#15803d' },
                              failed:           { bg: '#fee2e2', color: '#dc2626' },
                              processing:       { bg: '#fef3c7', color: '#b45309' },
                              scheduled:        { bg: '#eef2ff', color: '#4338ca' },
                              pending_approval: { bg: '#f3f0ff', color: '#7c3aed' },
                            }[status];
                            const badgeLabel = { posted: 'Posted', failed: 'Failed', processing: 'Processing', scheduled: 'Scheduled', pending_approval: 'Pending Approval' }[status];
                            return (
                              <div
                                key={post.id}
                                className="mb-2 position-relative"
                                style={{ cursor: 'pointer', borderRadius: 12, background: '#fff', border: '1px solid #c8d3dc', borderLeft: `3px solid ${accentColor}`, padding: '10px 10px 8px 10px', transition: 'all 0.2s ease', overflow: 'hidden' }}
                                onMouseOver={e => { e.currentTarget.style.boxShadow = '0 4px 16px rgba(0,0,0,0.08)'; e.currentTarget.style.transform = 'translateY(-2px)'; }}
                                onMouseOut={e => { e.currentTarget.style.boxShadow = 'none'; e.currentTarget.style.transform = 'translateY(0)'; }}
                                onClick={() => navigate(`/single-post/${post.id}`)}
                              >
                                {/* Trash — only for non-posted */}
                                {status !== 'posted' && (
                                  <button
                                    style={{ position: 'absolute', top: 8, right: 8, width: 24, height: 24, borderRadius: '50%', border: 'none', background: 'transparent', color: '#cbd5e1', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', padding: 0 }}
                                    onMouseOver={e => { e.currentTarget.style.background = '#fee2e2'; e.currentTarget.style.color = '#ef4444'; }}
                                    onMouseOut={e => { e.currentTarget.style.background = 'transparent'; e.currentTarget.style.color = '#cbd5e1'; }}
                                    onClick={e => { e.stopPropagation(); setPostToTrash(post); setShowTrashModal(true); }}
                                  ><Icon.Trash2 size={12} strokeWidth={2} /></button>
                                )}

                                {/* Status + time */}
                                <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginBottom: 6 }}>
                                  <span style={{ fontSize: '0.65rem', fontWeight: 700, borderRadius: 20, padding: '2px 8px', background: badgeStyle.bg, color: badgeStyle.color, display: 'inline-flex', alignItems: 'center', gap: 3 }}>
                                    {status === 'failed'     && <Icon.AlertCircle size={9} />}
                                    {status === 'processing' && <Icon.Loader size={9} />}
                                    {badgeLabel}
                                  </span>
                                  <span style={{ fontSize: '0.72rem', fontWeight: 600, color: '#475569', marginLeft: 'auto', paddingRight: status !== 'posted' ? 20 : 4, textAlign: 'right', lineHeight: 1.3 }}>
                                    {formatDateToUserTimezone(post.scheduled_date)}
                                    {post.timezone && (
                                      <div style={{ fontSize: '0.6rem', fontWeight: 500, color: '#94a3b8', marginTop: 1 }}>
                                        {getTimezoneAbbr(post.timezone)}
                                      </div>
                                    )}
                                  </span>
                                </div>

                                {/* Content preview */}
                                <div style={{ fontSize: '0.8rem', color: '#111', lineHeight: 1.45, display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', overflow: 'hidden', wordBreak: 'break-word', marginBottom: 8 }}>
                                  {post.content || post.videoTitle}
                                </div>

                                {/* Footer */}
                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                  {displayIcons(post.accounts)}
                                  <div style={{ display: 'flex', flexWrap: 'wrap', gap: 3 }}>
                                    {renderTikTokBadge(post.tiktok_status)}
                                    {(post.images.length || post.videos.length) > 0 && (
                                      <span style={{ fontSize: '0.65rem', fontWeight: 600, background: '#f1f5f9', color: '#64748b', borderRadius: 6, padding: '2px 6px', display: 'flex', alignItems: 'center', gap: 3 }}>
                                        <Icon.Image size={9} /> Media
                                      </span>
                                    )}
                                  </div>
                                </div>
                              </div>
                            );
                          })
                        )}

                        {/* New post button — only for today and future */}
                        {!isPast && (
                          <div
                            style={{ cursor: 'pointer', border: '1.5px dashed #a3e635', borderRadius: 10, padding: '7px 0', color: '#65a30d', background: '#f7fee7', fontSize: '0.72rem', fontWeight: 700, letterSpacing: '0.04em', textTransform: 'uppercase', transition: 'all 0.15s', marginTop: 4, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 4 }}
                            onMouseOver={e => { e.currentTarget.style.background = '#ecfccb'; e.currentTarget.style.borderColor = '#84cc16'; }}
                            onMouseOut={e => { e.currentTarget.style.background = '#f7fee7'; e.currentTarget.style.borderColor = '#a3e635'; }}
                            onClick={() => { setPendingDate(date); setShowQuickDateModal(true); }}
                          >
                            <Icon.Plus size={14} strokeWidth={3} /> New Post
                          </div>
                        )}

                      </div>
                    );
                  })}
                </div>
              </div>
            )}
          </div>
        </div>

{showTrashModal && (
  <div className="modal d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
    <div className="modal-dialog modal-dialog-centered">
      <div className="modal-content border-0 shadow" style={{ borderRadius: '15px' }}>
        <div className="modal-body text-center p-4">
          <div className="mb-3">
            <Icon.AlertCircle size={48} className="text-danger" />
          </div>
          <h4>Move to Trash?</h4>
          <p className="text-muted">Are you sure you want to delete this scheduled post? </p>

          <div className="d-flex justify-content-center mt-4">
            <button
              className="btn btn-light mr-2"
              onClick={() => setShowTrashModal(false)}
              disabled={isTrashing}
            >
              Cancel
            </button>
            <button
              className="btn btn-danger d-flex align-items-center"
              onClick={handleMoveToTrash}
              disabled={isTrashing}
            >
              {isTrashing ? (
                <><Icon.Loader size={16} className="mr-2 spin" /> Trashing...</>
              ) : (
                'Yes, Move to Trash'
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
)}



{/* Quick Date/Time Selection Modal */}
{showQuickDateModal && (
  <div className="modal d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 1050 }}>
    <div className="modal-dialog modal-dialog-centered" style={{ maxWidth: '400px' }}>
      <div className="modal-content border-0 shadow-lg" style={{ borderRadius: '15px' }}>
        <div className="modal-header border-0 pb-0">
          <h5 className="modal-title fw-bold">Schedule New Post</h5>
          <button type="button" className="btn-close" onClick={() => setShowQuickDateModal(false)}></button>
        </div>
        <div className="modal-body p-4">
          <div className="text-center mb-4">
            <div className="badge bg-light text-primary p-2 mb-2" style={{ fontSize: '1rem' }}>
              <Icon.Calendar size={18} className="mr-2" />
              {pendingDate && format(pendingDate, 'EEEE, dd MMM yyyy')}
            </div>
            <p className="text-muted small">Choose a time to start your draft</p>
          </div>

<div className="form-group">
  <label className="small fw-bold mb-3 d-flex align-items-center">
    <Icon.Clock size={14} className="mr-2 text-primary" /> Select Time
  </label>

  <div
    className="time-picker-grid d-flex flex-wrap justify-content-between"
    style={{
      maxHeight: '200px',
      overflowY: 'auto',
      paddingRight: '5px',
      gap: '8px'
    }}
  >
    {generateTimeSlots().map((time) => (
      <div
        key={time}
        onClick={() => setSelectedTime(time)}
        style={{
          flex: '0 0 30%', // 3 slots per row
          padding: '8px 0',
          textAlign: 'center',
          borderRadius: '8px',
          cursor: 'pointer',
          fontSize: '13px',
          fontWeight: selectedTime === time ? '700' : '500',
          backgroundColor: selectedTime === time ? '#eef2ff' : '#f8f9fa',
          color: selectedTime === time ? '#4f46e5' : '#4b5563',
          border: selectedTime === time ? '2px solid #4f46e5' : '1px solid #e5e7eb',
          transition: 'all 0.15s ease'
        }}
        onMouseOver={(e) => {
          if (selectedTime !== time) e.currentTarget.style.backgroundColor = '#f3f4f6';
        }}
        onMouseOut={(e) => {
          if (selectedTime !== time) e.currentTarget.style.backgroundColor = '#f8f9fa';
        }}
      >
        {/* Convert 14:30 to 2:30 PM for display */}
        {new Date(`2000-01-01T${time}`).toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' })}
      </div>
    ))}
  </div>
</div>

          <button
            className="btn btn-primary w-100 mt-4 py-2 fw-bold"
            style={{ borderRadius: '10px' }}
            onClick={() => {
              const datePart = format(pendingDate, 'yyyy-MM-dd');
              // Navigate with both date and time parameters
              navigate(`/write-post?date=${datePart}&time=${selectedTime}`);
              setShowQuickDateModal(false);
            }}
          >
            Confirm & Write Post
          </button>
        </div>
      </div>
    </div>
  </div>
)}


<style>
  {
    `
.time-picker-grid::-webkit-scrollbar {
  width: 6px;
}
.time-picker-grid::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 10px;
}
.time-picker-grid::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 10px;
}
.time-picker-grid::-webkit-scrollbar-thumb:hover {
  background: #7d8fa3;
}`
  }
</style>

      </div>

  );
}

export default Calendar;
